import compact from 'lodash/compact';
import { kmsClient } from 'api';
import { ARTICLES_FACEBOOK_PAGE_IMPACT_QUERY } from './articlesFacebookPageImpact.query';
import {
  ArticlesFacebookPageImpactQuery,
  ArticlesFacebookPageImpactQueryVariables
} from './__generated__/ArticlesFacebookPageImpactQuery';

export const fetchArticlesFacebookPageImpact = async (articleIds: string[]) => {
  const { data } = await kmsClient.query<ArticlesFacebookPageImpactQuery, ArticlesFacebookPageImpactQueryVariables>({
    query: ARTICLES_FACEBOOK_PAGE_IMPACT_QUERY,
    variables: { filter: { articleIds }, limit: articleIds.length },
    fetchPolicy: 'no-cache'
  });
  return compact((data.allArticles.edges ?? []).map((edge) => edge?.node));
};
